module.exports = __webpack_public_path__ + "static/media/GERMINI_banner_institucional_consumidor.09efca0f.jpg";